import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as Fiz from "../util/Fiz.js";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../server/objects/BudgetBeans.js";


import TPL from "../widget/launchpadV3.mustache";
import IHasRecurrencyHelper from "../lib/IHasRecurrencyHelper.js";
import { format } from "../lib/DateUtils.ts";

export {init,destroy}
Html.registerWidget('widget/launchpadV3',{init:init,destroy:destroy})

var currentIndex=0;

var urlBySection = {
    ACTIVITY:'wall.php',
    LIST:'tasks.php',
    MAP:'map.php',
    MESSAGE:'im.php',
    CONTACT:'contacts.php',
    GALLERY:'gallery.php',
    CALENDAR:'events.php',
    FAMILY:'settings.php?tab=settings_edit_members',
    MEALPLANNER:'mealplanner.php',
    RECIPEBOX:'recipebox.php',
    TIMETABLE:'timetable.php',
    SETTINGS:'settings.php',
    BUDGET:'budget.php',
    FILER:'document.php'
}
Html.register({
  launchpadclick:function(section){
    //FIXME a click is needed server side
    if(section!=='MESSAGE'){
      ApiServer.launchpadclick(section);
    }
    if(section==="PREMIUM"){
      Html.triggerbystring($(this),"takepremium",[])
    }else{
      libLocation.goTo(urlBySection[section]);
    }
  },
  launchpadclickaction:function(action,metaId,url){
    var clickaction = {
      INVITE:"inviteOnClickAction",
      WALL_VIEW:"launchpadclick|ACTIVITY",
      WALL_POST:"launchpadclick|ACTIVITY",
      PHOTO_CREATE:"launchpadclick|ACTIVITY",
      EVENT_VIEW:"evtclick|"+metaId,
      BIRTHDAY_VIEW:"evtclick|"+metaId,
      EVENT_CREATE:"eventcreate",
      CALENDAR:"launchpadclick|CALENDAR",
      CALENDAR_SETTINGS:"launchpadclick|CALENDAR",
      PROFILE_EDIT:"modaluseredit",
      FAMILY_CREATE:"modalcreatecircleonClickAction",
      FAMILY:"launchpadclick|FAMILY",
      URL:"openurl|"+url,
      MESSAGE:"launchpadclick|MESSAGE",
      LOCATION:"launchpadclick|LOCATION",
      CHECKIN_CREATE:"launchpadclick|LOCATION",
      PLACE_CREATE:"launchpadclick|LOCATION",
      LIST:"launchpadclick|LIST",
      LIST_CREATE:"launchpadclick|LIST",
      CONTACT:"launchpadclick|CONTACT",
      CONTACT_CREATE:"launchpadclick|CONTACT_CREATE",
      GALLERY:"launchpadclick|GALLERY",
      MEALPLANNER:"launchpadclick|MEALPLANNER",
      RECIPEBOX:"launchpadclick|RECIPEBOX",
      RECIPE_CREATE:"launchpadclick|RECIPEBOX",
      TIMETABLE:"launchpadclick|TIMETABLE",
      TIMETABLE_CREATE:"launchpadclick|TIMETABLE",
      SETTINGS:"launchpadclick|SETTINGS",
      MESSAGE_CREATE:"launchpadclick|MESSAGE",
      BUDGET:"launchpadclick|BUDGET",
      
      PREMIUM:"takepremium",
      PREMIUM_RECURRINGTASKS:"takepremium",
      PREMIUM_RECIPE:"takepremium",
      PREMIUM_MEALPLANNER:"takepremium",
      PREMIUM_CALENDARSYNC:"takepremium",
      PREMIUM_TIMETABLE:"takepremium",
      PREMIUM_LOCATION:"takepremium"
      
      
      
    }[action];
    if(clickaction){
      Html.triggerbystring($(this),clickaction,[])
    }else{
      console.log('error no clickaction for '+action)
    }
    
    
  }
});

Object.assign(ApiServer.types.LaunchpadBean.prototype,{
  onDecode(){
    this.eventDisplayDay = !!this.eventDayCount;
    this.eventDisplayWeek = !this.eventDayCount && this.eventWeekCount;
    this.eventDisplayMonth = !this.eventWeekCount && this.eventMonthCount;
    
    this.eventDisplayNone = !this.eventMonthCount && !this.eventWeekCount && !this.eventDayCount;
    
    if(this.timetableUpcomingEventDate){
      this.timetableUpcomingEventDisplayDate = format(this.timetableUpcomingEventDate,'dddd LT')
    }
  }
});  
Object.assign(ApiServer.types.LaunchpadActivityBean.prototype,{
  onDecode(){
    this.actionBackgroundColor = new Fiz.Color(this.actionBackgroundColor);
    this['is'+this.action] = true;
    
    if(this.items && this.items.length>3) {
      this.items.splice(2,this.items.length-2,
        new ApiServer.types.LaunchpadActivityItemBean({color:"#cccccc",title:i18n.get('launchpad.otherevents',(this.items.length-2))})
      );
    }
    
  }
});  

var theBean;
function display(container){
  if(theBean.activity){
    var nextIdx = theBean.activities.indexOf(theBean.activity)+1;
    if(nextIdx<theBean.activities.length){
      theBean.activity = theBean.activities[nextIdx]
    }
  }else{
    theBean.activity = theBean.activities[0]
  }
  Html.setHtml(container,TPL,theBean);  
  showIndex()

  container.delegate('.launchpad-nav>span','click',function(evt){
    for(let items=this.parentNode.children,i=0;i<items.length;i++){
      if(items[i]===this){
        currentIndex = i;
        break;  
      }
    }
    showIndex(true)
  })
  container.find(".launchpad-activities").swipe({
    swipeRight:function(){
      currentIndex--;
      setTimeout(function(){showIndex(true);},50)
      
    },
    swipeLeft:function(){
      currentIndex++;
      setTimeout(function(){showIndex(true);},50)
    }

  });

}
function showIndex(smooth){
  if(currentIndex<0) currentIndex=0;
  var 
    activities = $(".launchpad-activities>span");
  
  if(currentIndex>=activities.length) currentIndex=activities.length-1;
  var currentActivity = theBean.activities[currentIndex];
  
  $(".launchpad-nav>span").each((idx,span)=>{
    $(span).toggleClass('selected',idx===currentIndex);
  })
  
  if(currentActivity && currentActivity.screenSeenKeyEnum){
    ApiServer.launchpadseen(currentActivity.screenSeenKeyEnum,$.noop,$.noop)
  }
  activities.get(currentIndex).scrollIntoView({behavior :smooth?"smooth":"auto"})
}


function clean(){
  theBean = null;
  currentIndex=0;
  
}
amplify.subscribe('familyScopeChange sessionExpired',clean)

var currentContainer;

function init(container){
  currentContainer = container;
  loadAndDisplay()
  amplify.subscribe('modified',loadAndDisplay)
}
function destroy(container){
  currentContainer = null;
  amplify.unsubscribe('modified',loadAndDisplay)
}

function loadAndDisplay(){
  amplify.publish("budgetNeedRefresh")
  ApiServer.launchpadget3(theBean?theBean.token:null,null,null,function(launchpadBean){
    theBean = launchpadBean;
    
    var budget = getCurrentBudget();
    if(budget){
      
      theBean.budgetSummary = buildSummary(budget,budget.getTransactionList())
    }
    display(currentContainer);
  });
}